<script>

import accountService from '@/services/account.service'
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate"
import * as yup from 'yup'
import Icon from "@/components/Icon/Icon.vue"
import Dialog from 'primevue/dialog'

export default {
  name: 'AccountDelegateModal',
  components: {
      accountService,
      VeeForm,
      Field,
      ErrorMessage,
      Icon,
      Dialog,
  },
  data() {
      return {
        uuid: '',
        nom: '',
        email: '',
        write: false,
        showModal: false,
        traited: false,
      }
  },
  setup() {
      const schema = yup.object().shape({
        email: yup.string()
          .typeError("L\'email doit être rempli")
          .required("L\'email est obligatoire")
      });

      return {
          schema,
      }
  },
  props: {
    externUuidModal: {
        type: String
    },
    externNameModal: {
        type: String
    },
    externShowShareModal: {
        type: Boolean
    },
  },
  watch: {
    externUuidModal: function(newVal) {
        this.uuid = newVal
    },
    externNameModal: function(newVal) {
        this.nom = newVal
    },
    externShowShareModal: function(newVal) {
        this.showModal = newVal
    },
  },
  methods: {
      beforeClose () {
          this.showModal = false
          this.$emit('close', {
            traited: this.traited,
            name: this.nom,
          });
          this.traited = false
          this.uuid = ''
          this.nom = ''
          this.email = ''
          this.write = false
      },
      close() {
        this.showModal = false
      },
      handleDelegate(form) {
        accountService.delegate(this.uuid, this.email, this.write)
        .then((data) => {
            this.traited = true

            this.close()
        })
        .catch(err => {
          if(err.response.status == 404) {
            this.$moshaToast("L'utilisateur de cet email n'existe pas.", {
              timeout: 3000,
              hideProgressBar: true,
              type: 'warning',
              swipeClose: true,
              position: 'top-center',
            })
          }
          console.log(err)
        })
      },
  },
}

</script>

<template>
  <Dialog
        v-model:visible="showModal"
        modal
        class="flex justify-center items-center"
        :showHeader="false"
        :dismissableMask="true"
        :baseZIndex="1500"
        contentClass="relative p-0 rounded-lg bg-white dark:bg-gray-900"
        @hide="beforeClose"
    >
      <header class="bg-orange-300 p-2">
        <div class="text-right">
          <div @click="close()" class="cursor-pointer">Fermer</div>
        </div>
      </header>
      <div class="m-0 px-16 py-10 relative bg-white dark:bg-gray-900 border border-orange-300">
          <VeeForm @submit="handleDelegate" :validation-schema="schema" class="flex flex-col gap-4">
            <div class="form-group gap-4 mb-12">
              Pour pouvoir déléguer, la personne doit
              <br />
              avoir un compte.
            </div>
            <div class="form-group grid grid-cols-form-libre gap-4">
              <span class="flex flex-col justify-center">Nom de l'agenda</span>
              <Field v-model="uuid" name="uuid" class="w-48 form-control form-input" type="hidden" />
              {{ nom }}
            </div>
            <div class="form-group grid grid-cols-form-libre gap-4">
              <span class="flex flex-col justify-center">Email du délégué</span>
              <Field v-model="email" name="email" class="w-48 form-control form-input" type="text" />
            </div>
            <ErrorMessage name="nomAgenda" v-slot="{ message }">
              <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                {{ message }}
              </div>
            </ErrorMessage>
            <div class="form-group grid grid-cols-form-libre gap-4">
              <span class="flex flex-col justify-center">Écriture</span>
              <Field v-model="write" name="write" type="checkbox" :value="true" />
            </div>
            <button type="submit" class="btn flex justify-center mt-10" value="modifier">
              <span>Déléguer</span>
            </button>
          </VeeForm>
      </div>
  </Dialog>
</template>
